import React, { useState } from 'react';
import './History.css';
// Reuse the image loader from Image.js logic
const images = require.context('../Image/splashes', false, /\.(png|jpe?g|svg)$/);

const urlFromPath = (path) => {
  if (!path) return null;
  try {
    const filename = path.split('/').pop();
    return images(`./${filename}`);
  } catch (e) {
    console.error('History preview image not found:', path, e);
    return null;
  }
};

const History = ({ history = [] }) => {
  const OFFSET = 12;

  const [preview, setPreview] = useState({
    visible: false,
    left: 0,
    top: 0,
    src: null,
  });
  const [isOpen, setIsOpen] = useState(false);

  const showPreview = (event, loc) => {
    const src = urlFromPath(loc);
    setPreview({
      visible: !!src,
      left: event.clientX + OFFSET,
      top: event.clientY + OFFSET,
      src,
    });
  };

  const hidePreview = () => setPreview(prev => ({ ...prev, visible: false }));

  // no modal; clicking will select the item in the parent

  return (
    <>
      <button
        type="button"
        className="history-toggle"
        aria-label={isOpen ? 'Close history' : 'Open history'}
        onClick={() => setIsOpen(!isOpen)}
      >
        ☰ History
      </button>
      {isOpen && <div className="history-overlay" onClick={() => setIsOpen(false)} />}
      <div className={`history-container ${isOpen ? 'open' : ''}`}>
        <h2 className="history-title">History</h2>
        <div className="history-list">
          {history.length === 0 ? (
            <p className="no-history">No rounds played yet</p>
          ) : (
            history.map((item, index) => (
              <div
                key={index}
                className={`history-item ${item.isDaily ? 'clickable' : ''}`}
                onMouseMove={(e) => showPreview(e, item.loc)}
                onMouseLeave={hidePreview}
                onClick={() => {
                  if (!item.isDaily) return;
                  try {
                    const event = new CustomEvent('history:select', { detail: item });
                    window.dispatchEvent(event);
                  } catch (_) {}
                }}
              >
                <div className="history-skin-info">
                  <span className="history-skin-name">{item.skinName}</span>
                  <span className="history-champion">({item.champion})</span>
                </div>
                <div className="history-stats">
                  {!item.skipped && (
                    <div className={`history-guess-count ${item.guessCount > 1 ? 'high-guess-count' : ''}`}>
                      {item.guessCount} {item.guessCount === 1 ? 'guess' : 'guesses'}
                    </div>
                  )}
                  {item.challengeMode && (
                    <div className="challenge-mode-badge">
                      Challenge
                    </div>
                  )}
                  {item.skipped && (
                    <div className="skipped-badge">
                      Skipped
                    </div>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
        {preview.visible && (
          <div
            className="history-preview"
            style={{ left: preview.left, top: preview.top }}
          >
            <img src={preview.src} alt="Preview" />
          </div>
        )}
      </div>
    </>
  );
};

export default History;
